import { createRouter, createWebHistory } from 'vue-router'
import { type App } from 'vue'
import routes from './routes'
import { useUserStore } from '@/store/modules/user'
import { Storage } from '@/utils/Storage'
import { USER_FIRST_VISISIT_LINK, SHARE_TOKEN_KEY } from '@/enums/cacheEnum'
import wxConfig from '@/utils/wxConfig'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import VConsole from 'vconsole'
import { equipmentType } from '@/utils/common'
// new VConsole()
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   console.log('scrollBehavior', to, from, savedPosition)
  //   // 前往首页滚动逻辑
  //   if (to.name === 'Home') {
  //     return {
  //       top: 100,
  //     }
  //   }
  // },
})
const isIOS = equipmentType() === 'ios'

// IOS返回上一页分享处理
if (isIOS) {
  let isPageHide = false
  window.addEventListener('pageshow', function () {
    if (isPageHide) {
      // IOS 授权返回上一页空白 reload会导致分享入口链接变化
      if (location.pathname === '/author') {
        location.replace('/')
        return false
      }
      window.location.reload()
    }
  })
  window.addEventListener('pagehide', function () {
    isPageHide = true
  })
}

router.beforeEach((to, from, next) => {
  if (to.query?.debug === '1') {
    new VConsole()
  }
  const token = useUserStore().token
  if (to.query.shareToken) {
    Storage.setCookie(SHARE_TOKEN_KEY, to.query?.shareToken as string)
  }
  if (!token && to.path !== '/author') {
    to.query.t = String(Date.now())
    // 记录访问链接
    Storage.set(USER_FIRST_VISISIT_LINK, to.fullPath)
    console.log('Save visisit_link ===>', to.path)
    next({
      path: '/author',
      query: {
        shareToken: to.query?.shareToken,
      },
    })
    return false
  }
  // 兼容就资讯链接 跳转到新链接
  if (to.path === '/information/informationDetail') {
    next(`/talk-detail/${to.query.id}?detailType=1&refresh=true`)
  }
  to.meta.from = from
  next()
})

router.afterEach((to) => {
  if (!to.meta.isWxCustomShare && !to.meta.noShare) {
    console.log('wxConfig - 通用')
    wxConfig() // 微信分享-通用配置
  }
  const userStore = useUserStore()
  if (userStore.isOpenPopupRegisterPhone) {
    userStore.closePopupRegisterPhone()
  }
  document.title = String(to.meta.title || '')
})

export async function setupRouter(app: App) {
  app.use(router)

  // 监控工具
  if (process.env.VUE_APP_SENTRY === 'on') {
    Sentry.init({
      app,
      dsn: 'https://f0c40510f2584be68513e784cd5dd11f@o294891.ingest.sentry.io/5864363',
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins: ['localhost', 'my-site-url.com', /^\//],
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    })
  }

  // 路由准备就绪后挂载APP实例
  await router.isReady()
  // 隐藏首屏加载
  document.getElementById('loading-wrap')?.classList.add('hide')
}
export default router
